import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class HccCalIntroChi extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div>
              <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{ background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['5']}
                    defaultOpenKeys={['sub4']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />碘油沉积</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation-chi">碘油分析</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />预后预测</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation-chi">预后分析</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <div>
                            <Content style={{ marginLeft: 50, background: '#dcefef' }}>
                                <div style={{ marginLeft: 100, paddingTop:30, width: 600, height: 800, background: '#dcefef' }}>
                                <txt style={{fontSize:20,marginTop:50,}}>
                                <txt style={{fontSize:22,fontWeight:'bold'}}>欢迎访问肝细胞癌患者TACE疗效预后预测模块。</txt> 该模块旨在为进行肝细胞癌的TACE手术的临床医生提供一种辅助分析工具，对首次TACE的临床疗效进行科学有效的评估。
                                <br/><br/>该方法基于对中国北方约600例首次接受TACE治疗肝细胞癌患者的资料分析。 对登记患者的10余个治疗前临床指标进行统计分析，包括年龄，性别，Child-Pugh分级，术前AFP，原发肿瘤大小，转移，Karnofsky评分，BCLC等级，肿瘤包膜以及医学图像学预后标签，研究证明了 <txt style={{fontSize:22,fontWeight:'bold'}}>原发肿瘤直径，肿瘤转移，肿瘤包膜</txt> 是肝细胞癌患者TACE术后进展的三个显著因素。 因此，我们基于上述三个参数构建了定量预测预测模型。
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>注意：</txt>肿瘤转移分为以下四个亚组：无（状态：0），孤立性肝内转移（状态：1），多肝内转移或门静脉侵犯（状态：2）和远处转移（状态：3）。 肿瘤包膜分为存在与缺失两种类型。

                                </txt>
                                </div>
                            </Content>
                        </div>

                        <div>
                            <Content style={{ background: '#dcefef' }}>
                                <div style={{ marginLeft: 120, paddingTop:30,paddingRight:60, width: 600, height: 800, background: '#dcefef' }}>
                                
                                <txt style={{fontSize:28,fontWeight:'bold',}}>
                                使用介绍
                                </txt>
                        
                                <txt style={{fontSize:20}}>
                                <br/><br/>点击左侧导航页面上的 <txt style={{fontSize:20,fontWeight:'bold',}}>预后分析</txt> 按钮，滑动输入栏，选择原发肿瘤直径，肿瘤转移和肿瘤包膜等信息。点击“计算”按钮，将基于输入信息评估6个月和1年的TACE治疗进展预测概率。 

                                <br/><br/>此外，正如本模块所述的，本研究提供一种<txt style={{fontSize:22,fontWeight:'bold'}}>TACE术后1个月时的碘油沉积的定量化分层方法。</txt> 实验表明，术后1个月的碘油沉积是影响TACE疗效的重要因素。 因此，本研究还提出了TACE疗效的术后预后模型：除了上述三个因素外，术后一个月的碘油沉积也被用作预测TACE长期疗效的参数。 用户可以通过选择<txt style={{fontSize:22,fontWeight:'bold'}}> 添加TACE后一个月碘油沉积得分的模型，</txt> 辅助临床实践制定更加个体化与精准化的诊疗策略。
                                </txt>
   
                                </div>
                            </Content>
                        </div>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default HccCalIntroChi;